import { type Localization } from '../Localizations/Interface'
import { localizationNl } from '../Localizations/nl'
import { store } from '../Store/Store'

export function orchestrateConsole() {
  ;(window as any).besacc = (window as any).besacc ?? {}
  const besacc = (window as any).besacc

  besacc.getAllLocalization = () => {
    console.log(JSON.stringify(store.getState().interface.localization))
  }
  besacc.getNewLocalization = () => {
    const existingLocalization = localizationNl
    const currentLocalization = store.getState().interface.localization
    const newKeys: Localization = {}
    for (const sectionKey in currentLocalization) {
      const section = currentLocalization[sectionKey]
      for (const localizationKey in section) {
        const localization = section[localizationKey]
        if (existingLocalization[sectionKey]?.[localizationKey] == null) {
          if (newKeys[sectionKey] == null) newKeys[sectionKey] = {}
          newKeys[sectionKey][localizationKey] = { ...localization }
        }
      }
    }
    console.log(JSON.stringify(newKeys))
  }

  // besacc.getCompanies = () => {
  //   const cutOff = new Date('2024-02-18').getTime()
  //   console.log(
  //     JSON.stringify(
  //       store
  //         .getState()
  //         .data.companies.filter(
  //           (c) =>
  //             c.vatNumber.length > 2 &&
  //             c.vatNumber.substring(0, 2) === 'BE' &&
  //             (c.lastKpbCheck == null ||
  //               c.lastKpbCheck < cutOff ||
  //               c.lastKpbCheckSuccess == null ||
  //               !c.lastKpbCheckSuccess)
  //         )
  //     )
  //   )
  // }
}
